import { useState } from 'react';
import { axiosInstance } from '../services/axiosConfig';
import { BASE_URL } from '../utility/constants';

const useFormLibraryVisibility = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  const updateVisibility = async ({ form_library_id, is_public }) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axiosInstance.put(
        `${BASE_URL}v1/form-library/${form_library_id}/visibility`,
        { is_public }
      );
      setResponse(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, response, updateVisibility };
};

export default useFormLibraryVisibility; 